module.exports = __webpack_public_path__ + "img/news.437a28ed.png";